<template>
<!--环境信息表单页面-->
<el-form class="envForm" status-icon ref="env" label-width="45%" v-model="env" v-loading="loading">

  <div class="formDo">
    <!--占位空白盒子-->
  </div>

  <div class="formMsg">
    <!--表单组-->
    <env-form :formItem="env"></env-form>
  </div>

  <div class="formButton">
    <!--按钮操作区-->
    <el-button-group>
      <el-button @click="lastStep"><i class="el-icon-arrow-right el-icon-arrow-left"></i>上一步</el-button>
      <el-button icon="el-icon-check" :plain="true" @click="submit">保存信息</el-button>
      <el-button :disabled="next" @click="nextStep">下一步<i class="el-icon-arrow-right el-icon--right"></i></el-button>
    </el-button-group>
  </div>

</el-form>
</template>

<script>
import qs from 'qs'
import bus from './bus'
import arrayData from '../assets/javascript/dataProcess'
import envForm from '../assets/components/form'

export default {
  name: "newCase_env",
  components:{
    envForm
  },
  data() {
    return {
      /*加载动画*/
      loading: false,
      next: true,
      env: []
    }
  },
  methods: {
    submit() {
      let formdata = {};
      if (this.env[0].value === '' || this.env[1].value === '' || this.env[2].value === '' || this.env[3].value === '' || this.env[4].value === '') {
        for (let i = 0; i < 5; i++) {
          if (this.env[i].value === "") {
            this.$set(this.env[i], "warning", 1);
            this.$set(this.env[i], "warningMsg", "必填信息不得为空");
          }
        }
      } else {
        for (let i = 0; i < this.env.length; i++) {
          formdata[this.env[i].name] = this.env[i].value;
        }
        this.loading = true;
        this.$http.post(
            '/nais/environment',
            qs.stringify(formdata), {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
              }
            }
          )
          .then((res) => {
            this.$message({
              message: "环境信息保存成功",
              type: 'success',
              center: true,
              duration: 1000
            });
            this.next = false;
            this.$nextTick(
              this.loading = false,
            );
          })
          .catch((err) => {
            console.log(err);
            this.$nextTick(
              this.loading = false,
            );
          });
        this.next = false;
      }
    },
    nextStep() {
      bus.$emit('envNext', 2);
    },
    lastStep() {
      bus.$emit('envLast', 0);
    }
  },
  created() {
    let length1 = arrayData.data1.env.length;
    /*渲染数组*/
    this.env = arrayData.data1.env;
    for (let i = 0; i < length1; i++) {
      arrayData.data1.env[i].value = '';
    }
    /*接收caseNUmber*/
    bus.$on('caseNumber', msg => {
      this.env[0].value = msg;
    });
  }
}
</script>

<style scoped>
.envForm {
  width: 98%;
  height: 89%;
  margin-top: 0.5%;
  background-color: #F5F7FA;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
}

.formDo {
  height: 10%;
}

.formMsg {
  width: calc(100% - 10px);
  height: 78%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-content: flex-start;
  padding-right: 10px;
  overflow-y: auto;
}

.formButton {
  width: 100%;
  height: 10%;
  margin-top: 1%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.el-form-item {
  width: 33%;
}

.el-form-item__content {
  width: calc(100% - 45%);
}

.el-input {
  width: 100%;
}

.el-select {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/data/newCase_env.vue